import {
  homeTranslations,
  servicesTranslations,
  serviceCategoriesTranslations,
  termsTranslations,
  privacyTranslations,
  blogTranslations,
  communityTranslations,
  contactTranslations,
  eventsTranslations,
  aboutTranslations
} from './ar/index'

export const arTranslations = {
  ...homeTranslations,
  ...servicesTranslations,
  ...serviceCategoriesTranslations,
  ...termsTranslations,
  ...privacyTranslations,
  ...blogTranslations,
  ...communityTranslations,
  ...contactTranslations,
  ...eventsTranslations,
  ...aboutTranslations
}
